export const featureManagementGermanLocalization = {
  screens: {
    settings: {
      title: 'Features',
      reset: 'Lokale Feature-Einstellungen löschen'
    }
  }
};

// Guarantees that both translations have the same structure
type FeatureManagementLocales = typeof featureManagementGermanLocalization;

export const featureManagementEnglishLocalization: FeatureManagementLocales = {
  screens: {
    settings: {
      title: 'Features',
      reset: 'Reset local feature settings'
    }
  }
};
